module.exports = __webpack_public_path__ + "img/97.f1397913.jpg";